// Utils
import { safeLocalStorage as localStorage } from 'utils'

export const AB_CONFIG_KEY = 'ab-config'

export const randomizeIndex = (nrOfIndices: number) => Math.floor(Math.random() * Math.floor(nrOfIndices))

const localStorageAbString = localStorage.getItem(AB_CONFIG_KEY)
const localStorageAb = JSON.parse(localStorageAbString || '{}')

const registerExperimentAtGa = (experimentId: number, variantId: number) => {
  ga('set', 'exp', `${experimentId}.${variantId}`)
  ga('send', 'event', 'abtest', 'trigger', `experiment: ${experimentId}, variant: ${variantId}`, { nonInteraction: 1 })
}

const setupAndRegisterInitialState = () => {
  Object.keys(localStorageAb).forEach(experimentId => {
    registerExperimentAtGa(+experimentId, localStorageAb[experimentId])
  })
  return localStorageAb
}

const initialState = setupAndRegisterInitialState()

const reducer = (state: Record<string, unknown> = initialState, action: Record<string, unknown>) => {
  switch (action.type) {
    case 'REGISTER_EXPERIMENT': {
      const { experimentId, nrOfVariants } = action
      const variantId = state.get(experimentId)
      if (variantId === undefined) {
        const randomVariantId = randomizeIndex(nrOfVariants)
        registerExperimentAtGa(experimentId, randomVariantId)
        const newState = state.set(experimentId, randomVariantId)
        localStorage.setItem(AB_CONFIG_KEY, JSON.stringify(newState))
        return newState
      }
      return state
    }

    default:
      return state
  }
}

export default reducer
